import { render } from "./StrategyFields.vue?vue&type=template&id=54ffc3ef"
import script from "./StrategyFields.vue?vue&type=script&lang=js"
export * from "./StrategyFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__